module.exports = {"type":"FileArchive","name":"文档管理","defaultName":"未命名文档管理","placeholder":"请输入文档管理名称……","icon":"bico-file","custom":true,"routeName":"FileArchive","listShowFields":[],"dropdownList":[]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bri-vtools/src/datas/app/appModuleData/modules/FileArchive.json
// module id = 71xO
// module chunks = 39